import React, { useState } from 'react';
import clsx from 'clsx';
import { EditRecordDialog, RemoveContractRecordDialog } from '@icoach/nonMember/dialog';
import { Icons, Card, Divider, IconButton, Stack, Typography, Box } from "@curves/ui-base";
import { parseDate } from '@util/moment';
import { isFunction } from '@util/utils';

const ContactRecordCard = ({ className, title, notes, contactDate, contactResultTypeText, coachName, contactID, customerID, openDeleteDialog: openDeleteDialogFn, openEditDialog: openEditDialogFn, handleEditContact, handleDeleteContact, isShowTime = false }) => {
	const [isOpen, setOpen] = useState(null);
	const displayFormat = isShowTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD';

	const openDeleteDialog = () => {
		isFunction(openDeleteDialogFn) && openDeleteDialogFn();
		setOpen('remove');
	};

	const openEditDialog = () => {
		isFunction(openEditDialogFn) && openEditDialogFn();
		setOpen('edit');
	};

	const closeDialog = () => {
		setOpen(null);
	};

	const handleEditEvent = async (customerID, contactID, result) => {
		if (isFunction(handleEditContact)) {
			let resp = await handleEditContact(customerID, contactID, result);
			if (resp) closeDialog();
		}
	};

	const handleDeleteEvent = async (customerID, contactID) => {
		if (isFunction(handleDeleteContact)) {
			let resp = await handleDeleteContact(customerID, contactID);
			if (resp) closeDialog();
		}
	};

	return (
		<Card isOverflowHidden className={clsx('contact-record-card', className)}>
			<Card.CardContent>
				<Stack justifyContent="space-between" className="pt-2 px-2">
					<Box component="span" className="contact-record-card-markbook">
						<Typography variant="h5" className="contact-record-card-date">
							{parseDate(contactDate, displayFormat)}
						</Typography>
					</Box>
					<Box>
						{handleEditContact && (
							<IconButton onClick={openEditDialog}>
								<Icons.Edit />
							</IconButton>
						)}
						{handleDeleteContact && (
							<IconButton onClick={openDeleteDialog}>
								<Icons.Trash />
							</IconButton>
						)}
					</Box>
				</Stack>
				<Stack className="px-3 py-3" justifyContent="space-between">
					<Box className="overflow-hidden info-item">
						<Box component="span" className="contact-record-card-label">
							狀態
						</Box>
						<Box component="span" className="contact-record-card-label-text">
							{contactResultTypeText}
						</Box>
					</Box>
					<Box className="overflow-hidden info-item text-right">
						<Box component="span" className="contact-record-card-label">
							擔當
						</Box>
						<Box component="span" className="contact-record-card-label-text">
							{coachName}
						</Box>
					</Box>
				</Stack>
			</Card.CardContent>
			<Divider />
			<Card.CardContent>
				<Box className="px-3">
					<Typography variant="h6" className="title py-2">
						{title}
					</Typography>
					<Typography className="content pb-4">{notes}</Typography>
				</Box>
			</Card.CardContent>
			<RemoveContractRecordDialog open={isOpen === 'remove'} onClose={() => setOpen(null)} refresh={() => handleDeleteEvent(customerID, contactID)} />
			<EditRecordDialog open={isOpen === 'edit'} setOpen={() => setOpen(null)} doAction={_par => handleEditEvent(customerID, contactID, _par)} title={title} notes={notes} />
		</Card>
	);
};

export default ContactRecordCard;
